if (!customElements.get("focean-story-video")) {
  customElements.define("focean-story-video", class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector("video");
      if (!this.video) return;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const playback = this.video.play();
            if (playback) playback.catch(() => {});
          } else {
            this.video.pause();
          }
        });
      }, { threshold: 0.25 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}
